import Stack from '@mui/material/Stack';
import React from 'react';
import { useNavigate } from "react-router-dom";
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import NotifyMessagePage from '../../ui-parts/NotifyMessagePage';
import { utility } from '../../utility';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/**
 * CookieAcceptance Page Component
 */
const CookieAcceptance = () => {

  // 変数・State
  const screenId = 'MyM702';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings } = useWebContext(screenId);
  const navigate = useNavigate();
  const isPc = useMediaQuery(mediaQuery.pc);

  // I Agree押下時処理
  const onClickAgree = () => {
    // APIコールバック処理
    const callbackUpdateRequestContext = (result) => {
      // 問題無ければHome画面へ、異常があればエラー画面へ遷移
      result?.PostResult
        ? navigate('/MyM102')
        : navigate('/MyM999');
    }
    // UserInfoController.csのAPI呼び出し
    apiRequest.requestJson('api/user-info/cookie-accept', 'POST', callbackUpdateRequestContext);
  };

  return (
    <>
      <NotifyMessagePage>
        <MyMLabel fontSize={isPc ? '1.25rem':'1rem'}>{controlSettings.LabelList.lblCookieAcceptance}</MyMLabel>
        <Stack direction='row' spacing={3} className='my-3'>
          <MyMButton onClick={onClickAgree}>{controlSettings.LabelList.btnAgree}</MyMButton>
          <MyMButton onClick={() => utility.transferTopPage()}>{controlSettings.LabelList.btnDisagree}</MyMButton>
        </Stack>
        <NavigateLink fontSize='1.25rem' to='/MyM904' newTabNavigate={true}>{controlSettings.LabelList.lnkPrivacyPolicy}</NavigateLink>
      </NotifyMessagePage>
    </>
  );
};
export default CookieAcceptance;
